<template>
  <div class="islet">
    <a href @click.prevent="$emit('input', !value)">
      {{ lang.get('judging.fast_start.scoring.advanced') }}
      <icon :name="'chevron-' + (value ? 'down' : 'up')" />
    </a>
  </div>
</template>

<script>
import Icon from '@/lib/components/Shared/Icon';

export default {
  inject: ['lang'],
  components: {
    Icon
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
};
</script>
